// extracted by mini-css-extract-plugin
module.exports = {"trekkspill":"Trekkspill_trekkspill__RG9KP","item":"Trekkspill_item____979","header":"Trekkspill_header__ZTaP5"};